var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1731)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1731",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3973 6L23.3973 16",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3973 6L23.3973 16",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39734 16H41.3973",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3573 18.3412L23.416 41.9999L4.47734 18.3412C4.16799 17.9787 3.99805 17.5178 3.99805 17.0412C3.99805 16.5647 4.16799 16.1037 4.47734 15.7412L12.7973 6.66124C12.9874 6.44998 13.2203 6.28171 13.4806 6.16766C13.7409 6.05362 14.0225 5.99643 14.3067 5.99991H32.5307C32.8128 5.99761 33.0923 6.05512 33.3506 6.16865C33.6089 6.28218 33.8402 6.44915 34.0293 6.65857L42.28 15.7252C42.6007 16.0781 42.7849 16.5339 42.7996 17.0105C42.8143 17.4871 42.6584 17.9533 42.36 18.3252L42.3573 18.3412Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleIcon);
export default __webpack_public_path__ + "static/media/sale-icon.65eb970344b74ca3d6c837cbdc6babe1.svg";
export { ForwardRef as ReactComponent };